// Lightbox swipe gesture constants
export const SWIPE_THRESHOLD = 100;
export const VELOCITY_THRESHOLD = 0.5;
export const SLIDE_OUT_DURATION = 400;
export const SNAP_BACK_DURATION = 300;
export const ROTATION_FACTOR = 0.15;
export const DRAG_SCALE = 1.05;
export const EXIT_ROTATION_DEG = 30;
export const EXIT_WIDTH_MULTIPLIER = 1.5;
export const VELOCITY_Y_PROJECTION = 100;
export const VIDEO_CONTROLS_HEIGHT = 60;

/**
 * Layer for anything opened from inside the lightbox — its more-menu and the
 * delete confirmation.
 *
 * The lightbox overlay sits at the DS `popup` layer (3000), and DS layers
 * portal to `<body>` below it by default — menus at `popover` (2000), a
 * `Dialog`'s overlay at `1` — so each opened underneath the lightbox and the
 * click looked like it did nothing. This is the DS `tooltip` layer
 * (`--stacking-context-tooltip`), as a number because `SuggestionMenuV2.zIndex`
 * and `Dialog.zIndex` take one and the DS exports only CSS-var strings.
 */
export const ABOVE_LIGHTBOX_Z_INDEX = 4000;
